var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoInvert = function SvgLogoInvert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 124 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.77 18.645 0 73.48 31.807v141.221L55.135 184 0 152.193V10.77Z",
    fill: "var(--a, #000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.958 31.006c-9.69 0-17.541 7.886-17.541 17.611 0 9.725 7.851 17.612 17.541 17.612 9.69 0 17.542-7.887 17.542-17.612 0-9.725-7.852-17.611-17.542-17.611ZM92.424 48.617c0-7.508 6.061-13.592 13.534-13.592 7.473 0 13.535 6.084 13.535 13.592 0 7.509-6.062 13.592-13.535 13.592-7.472 0-13.534-6.083-13.534-13.592Z",
    fill: "var(--a, #000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.276 54.656c.035.851.276 1.68.702 2.416h-4.11a5.976 5.976 0 0 1-.602-2.416v-1.811c-.2-1.712-.601-2.215-2.105-2.215h-3.609v6.442h-3.91V39.76h7.72c3.909 0 6.215 1.812 6.215 5.033a3.942 3.942 0 0 1-.569 2.355 3.913 3.913 0 0 1-1.837 1.57c1.303.605 1.905 1.813 2.005 3.624l.1 2.315Zm-9.824-7.247h3.609c1.604 0 2.406-.704 2.406-2.114 0-1.409-.802-2.113-2.506-2.113h-3.509v4.227Z",
    fill: "var(--a, #000)"
  })));
};

export default SvgLogoInvert;